import React from 'react';
import { sanitizeHtml } from '../../../helper/utils.helper';

const BodyContent = ({ body }) => {
  return (
    <>
      <div
        className="body-content margin-top--xl"
        style={{ minHeight: '50px' }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }}></div>
      <style>
        {`
    .body-content p,
    .body-content li {
    margin-top:20px;
      line-height: 1.8;
    }
      .body-content a {
      color: blue;
      }
  `}
      </style>
    </>
  );
};

export default BodyContent;
